import { cognitoService } from './cognito.service';

export interface PaymentsResponse {
  dni: string;
  total: number;
  payments: Payment[];
}

export interface Payment {
  dni: string;
  createdAt: string;
  url: string;
  email: string;
  fullName: string;
  companyName: string;
  companyRuc: string;
}

class ApiService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = process.env.REACT_APP_API_URL || 'https://p5h5biayza.execute-api.us-east-1.amazonaws.com/prod';
  }

  private async getUserDni(): Promise<string> {
    try {
      const userAttributes = await cognitoService.getUserAttributes();
      const dni = userAttributes['custom:dni'];
      
      if (!dni) {
        throw new Error('No se encontró el DNI en el perfil del usuario');
      }
      
      return dni;
    } catch (error) {
      console.error('Error obteniendo DNI:', error);
      throw new Error('No se pudo obtener el DNI del usuario');
    }
  }

  async getMyPayments(): Promise<PaymentsResponse> {
    try {
      const [token, dni] = await Promise.all([
        cognitoService.getIdToken(),
        this.getUserDni()
      ]);

      console.log(`getMyPayments: ${dni}`);

      const response = await fetch(`${this.baseUrl}/payment-slips/${dni}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      
      if (data.success && data.data) {
        return data.data;
      } else if (data.payments) {
        return data;
      } else {
        return {
          dni,
          total: data.length || 0,
          payments: data.payments || data || []
        };
      }
    } catch (error) {
      console.error('Error en getMisPayments:', error);
      throw error;
    }
  }

}

export const apiService = new ApiService();
export default apiService;